import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js/instance/trim';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import * as React from 'react';
import { hooks, api } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import elementClosest from 'element-closest';
import useUnmount from 'react-use/lib/useUnmount';
import { prependPrefix } from '../../utils/style.js';
import { SearchHistory } from './components/search-history.js';
import { SearchSuggest } from './components/search-suggest.js';
import { LEGACY_SEARCH_BOX_CLASSNAME, SEARCH_ITEM_CLASSNAME, SEARCH_KEYWORD_CLASSNAME } from './utils/index.js';
import { saveKeyword } from './utils/history.js';

elementClosest(window);
var LegacyDesktopSearchBox = function LegacyDesktopSearchBox(_ref) {
  var className = _ref.className,
      _ref$showSearchSugges = _ref.showSearchSuggest,
      showSearchSuggest = _ref$showSearchSugges === void 0 ? true : _ref$showSearchSugges,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '搜索音频、剧集、直播、用户' : _ref$placeholder,
      keywordValue = _ref.keywordValue,
      onSearch = _ref.onSearch,
      onSubmit = _ref.onSubmit,
      onInputChange = _ref.onInputChange;

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      keyword = _React$useState2[0],
      setKeyword = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      selectType = _React$useState4[0],
      setSelectType = _React$useState4[1];

  var searchFormRef = React.useRef(null);

  var hideSearchSuggestion = function hideSearchSuggestion() {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    removeClickListener();
    setSelectType(undefined);
  };

  var documentClickHandler = hooks.useEventCallback(function (e) {
    var _e$target, _e$target2, _e$target2$classList, _e$target3, _e$target3$classList;

    var isIncludeSearchBoxWrapClassname = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.closest(".".concat(LEGACY_SEARCH_BOX_CLASSNAME));
    var isClickSuggestionItem = e === null || e === void 0 ? void 0 : (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : (_e$target2$classList = _e$target2.classList) === null || _e$target2$classList === void 0 ? void 0 : _e$target2$classList.contains(SEARCH_ITEM_CLASSNAME);
    var isClickSuggestionKeyword = e === null || e === void 0 ? void 0 : (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : (_e$target3$classList = _e$target3.classList) === null || _e$target3$classList === void 0 ? void 0 : _e$target3$classList.contains(SEARCH_KEYWORD_CLASSNAME); // 点击下拉框每一项以及关键词时隐藏下拉框

    if (isClickSuggestionItem || isClickSuggestionKeyword) {
      hideSearchSuggestion();
    } // 点击搜索框外时隐藏下拉框


    if (!isIncludeSearchBoxWrapClassname) {
      hideSearchSuggestion();
    }
  });

  var addClickListener = function addClickListener() {
    document.addEventListener('click', documentClickHandler, false);
  };

  var removeClickListener = function removeClickListener() {
    document.removeEventListener('click', documentClickHandler, false);
  };

  var updateSearchBoxState = function updateSearchBoxState(value) {
    if (typeof value === 'string' && value.length) {
      setKeyword(value);
      setSelectType('suggest');
    } else {
      setKeyword('');
      setSelectType('history');
    }
  };

  var handleInputFocus = function handleInputFocus() {
    addClickListener();
    updateSearchBoxState(keyword);
  };

  var handleInputChange = function handleInputChange(e) {
    var search = e.target.value;
    updateSearchBoxState(search);
    onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(search);
  };

  var handleSearch = function handleSearch(e) {
    e.preventDefault();
    hideSearchSuggestion();

    if (onSearch) {
      onSearch();
    } else {
      var _context;

      var searchKeyword = _trimInstanceProperty(keyword).call(keyword);

      saveKeyword(searchKeyword);
      var searchPath = "".concat(api.MISSEVAN_API_PREFIX_URL, "/sound/search?");
      var searchQuery = "s=".concat(encodeURIComponent(searchKeyword));
      window.open(_concatInstanceProperty(_context = "".concat(searchPath)).call(_context, searchQuery), '_blank');
    }
  };

  React.useEffect(function () {
    if (keywordValue !== keyword) {
      setKeyword(keywordValue || '');
    }
  }, [keywordValue]);
  useUnmount(removeClickListener);
  var isLargeType = type === 'large';
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(LEGACY_SEARCH_BOX_CLASSNAME, className)
  }, /*#__PURE__*/React.createElement("form", {
    className: "search-input-".concat(type),
    onSubmit: handleSearch,
    ref: searchFormRef
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    autoComplete: "off",
    placeholder: placeholder,
    className: "search-box-input",
    value: keyword,
    maxLength: 20,
    onChange: handleInputChange,
    onFocus: handleInputFocus
  }), /*#__PURE__*/React.createElement("button", {
    className: "search-box-btn"
  }, isLargeType && '搜索'), showSearchSuggest && /*#__PURE__*/React.createElement("div", {
    className: prependPrefix('search-suggest')
  }, selectType === 'history' && /*#__PURE__*/React.createElement(SearchHistory, {
    onSubmit: onSubmit,
    searchFormRef: searchFormRef,
    type: type,
    hideSearchSuggestion: hideSearchSuggestion
  }), selectType === 'suggest' && /*#__PURE__*/React.createElement(SearchSuggest, {
    onSubmit: onSubmit,
    keyword: keyword,
    searchFormRef: searchFormRef,
    type: type,
    hideSearchSuggestion: hideSearchSuggestion
  }))));
};

export { LegacyDesktopSearchBox };
